import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var genLayoutLightStyle = function genLayoutLightStyle(token) {
  var _$concat;
  var componentCls = token.componentCls,
    bodyBg = token.bodyBg,
    lightSiderBg = token.lightSiderBg,
    lightTriggerBg = token.lightTriggerBg,
    lightTriggerColor = token.lightTriggerColor;
  return _defineProperty({}, "".concat(componentCls, "-sider-light"), (_$concat = {
    background: lightSiderBg
  }, _defineProperty(_$concat, "".concat(componentCls, "-sider-trigger"), {
    color: lightTriggerColor,
    background: lightTriggerBg
  }), _defineProperty(_$concat, "".concat(componentCls, "-sider-zero-width-trigger"), {
    color: lightTriggerColor,
    background: lightTriggerBg,
    border: "1px solid ".concat(bodyBg),
    borderInlineStart: 0
  }), _$concat));
};
export default genLayoutLightStyle;